module.exports = __webpack_public_path__ + "static/img/teams.bed74871.svg";